export default __webpack_public_path__ + "static/media/PASIEKA-Home.f347bae4.jpg";